import { createSlice } from "@reduxjs/toolkit";
export const workspaceSlice = createSlice({
    name: 'workspace',
    initialState: {
        quicksearchMode: null,
    },
    reducers: {
        hideQuicksearch: (state) => {
            state.quicksearchMode = null;
        },
        openNewResourcePicker: (state) => {
            state.quicksearchMode = 'new-resource-picker';
        },
        toggleQuicksearch: (state) => {
            state.quicksearchMode = state.quicksearchMode
                ? null
                : 'resource-search';
        }
    },
    selectors: {
        getQuicksearchMode: (state) => state.quicksearchMode,
        isQuicksearchVisible: (state) => Boolean(state.quicksearchMode),
    }
});
//# sourceMappingURL=workspaceSlice.js.map